"use client";

import { FC } from "react";
import { useI18n } from "@/i18n/client";
import { getLineItemForProduct } from "@/utils/cart-utils";
import { useCartContext } from "@/providers/CartContextProvider";
import { useProductContext } from "@/providers/ProductContextProvider";
import FormattedPrice from "@/components/UI/FormattedPrice/FormattedPrice";
import styles from "./ProductTotalPrice.module.scss";
import { ProductData } from "@/lib/5874/types";
import { ClickData } from "@/lib/searchspring/tracker";

interface ProductTotalPriceProps {
	price?: number;
}

const ProductTotalPrice: FC<ProductTotalPriceProps> = ({ price }) => {
	const { product } = useProductContext();
	const { cart } = useCartContext();
	const t = useI18n();

	if (price) {
		return (
			<p className={styles.total}>
				{t("cart.total")}
				<FormattedPrice price={price} />
			</p>
		);
	}

	const lineItem = getLineItemForProduct(cart, product);

	if (!lineItem) return <></>;

	const quantity = lineItem ? lineItem.quantity : 1;

	return (
		<p className={styles.total}>
			{t("cart.total")}
			<FormattedPrice price={product.pricesExTax.price.value * quantity} />
		</p>
	);
};

export default ProductTotalPrice;
